import { render } from "./SightEdit.vue?vue&type=template&id=8af324b8&scoped=true"
import script from "./SightEdit.vue?vue&type=script&lang=js"
export * from "./SightEdit.vue?vue&type=script&lang=js"

import "./SightEdit.vue?vue&type=style&index=0&id=8af324b8&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af324b8"]])

export default __exports__